import { Path } from '@/main/router/routerPath';
import { PracovniPozice } from '@/modules/servis/zakazka/pracovniPozice';
import { ZakazkovyList } from '@/modules/servis/zakazka/zakazkovyList';
import { SplitBilling } from "@/modules/servis/zakazka/SplitBilling";

import { CRUMB_LABEL_KEY, NAME } from './constants';
import Edit from './EditBase.vue';
import List from './List.vue';
import { CiziVykony } from './ciziVykony';
import { NahradniDily } from './nahradniDily';
import { Korekce } from './korekce';
import { Zapujcky } from './zapujcky';
import { ServisniPakety } from './servisniPakety';
import { Pneu } from './pneu';
import { ServicePackage } from './ServicePackage';
import { Audatex } from './Audatex';
import { ServiceJobDetails } from './ServiceJobDetails';
import { ServiceJobSplitBilling } from './ServiceJobSplitBilling';

export const router = new Path().addChildren([
	new Path(NAME, { List, Edit, SelectList: List }, CRUMB_LABEL_KEY),
	CiziVykony.router,
	NahradniDily.router,
	Korekce.router,
	PracovniPozice.router,
	ZakazkovyList.router,
	Zapujcky.router,
	Pneu.router,
	ServisniPakety.router,
	ServicePackage.router,
	SplitBilling.router,	
	Audatex.router,
	ServiceJobDetails.router,
	ServiceJobSplitBilling.router,
]);
